export const arrayProto = Array.prototype;
export const objProto = Object.prototype;
export const push = arrayProto.push;
export const pop = arrayProto.pop;
export const slice = arrayProto.slice;
export const splice = arrayProto.splice;
export const toString = objProto.toString;
export const hasOwnProperty = objProto.hasOwnProperty;
